import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCookiesConsent } from './hooks/useCookiesConsent';

// Using the CSS copied from the manual instead of SCSS module
import '../../../assets/styles/cookie-consent.css';

export const CookiesConsentModal: React.FC = () => {
  const {
    isVisible,
    isOverlayVisible,
    setIsOverlayVisible,
    preferences,
    setPreferences,
    handleAcceptAll,
    handleEssentialOnly,
    savePreferences
  } = useCookiesConsent();

  // Local state for the modal toggles before saving
  const [tempPrefs, setTempPrefs] = useState(preferences);

  // Sync tempPrefs when overlay opens
  const openOverlay = () => {
    setTempPrefs(preferences);
    setIsOverlayVisible(true);
  };

  const handleSaveModal = () => {
    savePreferences(tempPrefs);
  };

  if (!isVisible && !isOverlayVisible) return null;

  return (
    <>
      {isVisible && !isOverlayVisible && (
        <div className="bw-cookie-consent" role="region" aria-label="Preferencias de cookies">
          <div className="bw-cookie-card">
            <h2 className="bw-cookie-title">Cookies y privacidad</h2>
            <p className="bw-cookie-copy">
              Bodhiwell® usa cookies necesarias para funcionar y, con tu permiso, cookies de preferencias y analíticas para recordar tus elecciones, medir el uso de la plataforma y mejorar la experiencia.
            </p>
            <div className="bw-cookie-actions">
              <button className="bw-cookie-btn bw-cookie-btn--primary" type="button" onClick={handleAcceptAll}>
                Aceptar todas
              </button>
              <button className="bw-cookie-btn bw-cookie-btn--secondary" type="button" onClick={handleEssentialOnly}>
                Solo necesarias
              </button>
            </div>
            <div className="bw-cookie-meta">
              <button type="button" onClick={openOverlay}>Configurar</button>
              <Link className="bw-cookie-link" to="/politica-de-cookies">Política de cookies</Link>
            </div>
          </div>
        </div>
      )}

      {isOverlayVisible && (
        <div className="bw-cookie-overlay">
          <article className="bw-cookie-modal" role="dialog" aria-modal="true" aria-labelledby="prefsTitle">
            <header className="bw-cookie-modal__header">
              <div>
                <h2 id="prefsTitle">Preferencias de cookies</h2>
                <p>Elegí qué tecnologías opcionales querés permitir. Las necesarias sostienen funciones básicas y no se usan para seguimiento comercial.</p>
              </div>
              <button className="bw-cookie-close" type="button" aria-label="Cerrar configuración" onClick={() => setIsOverlayVisible(false)}>
                ×
              </button>
            </header>
            <div className="bw-cookie-options">
              <div className="bw-cookie-option">
                <div>
                  <h3>Necesarias</h3>
                  <p>Permiten seguridad, sesión, navegación y funciones indispensables de Bodhiwell.</p>
                </div>
                <span className="bw-cookie-required">Siempre activas</span>
              </div>
              <div className="bw-cookie-option">
                <div>
                  <h3>Preferencias</h3>
                  <p>Recuerdan configuraciones o elecciones para simplificar futuras visitas.</p>
                </div>
                <label className="bw-cookie-switch">
                  <input
                    type="checkbox"
                    checked={tempPrefs.preferences}
                    onChange={(e) => setTempPrefs({ ...tempPrefs, preferences: e.target.checked })}
                  />
                  <span aria-hidden="true"></span>
                </label>
              </div>
              <div className="bw-cookie-option">
                <div>
                  <h3>Analíticas</h3>
                  <p>Ayudan a comprender de forma agregada el uso de la plataforma y mejorar la experiencia.</p>
                </div>
                <label className="bw-cookie-switch">
                  <input
                    type="checkbox"
                    checked={tempPrefs.analytics}
                    onChange={(e) => setTempPrefs({ ...tempPrefs, analytics: e.target.checked })}
                  />
                  <span aria-hidden="true"></span>
                </label>
              </div>
            </div>
            <p className="bw-cookie-modal__note">
              Las tecnologías opcionales permanecen desactivadas hasta que el usuario las autoriza. La elección debe poder modificarse posteriormente desde “Preferencias de cookies”.
            </p>
            <footer className="bw-cookie-modal__footer">
              <button className="bw-cookie-btn bw-cookie-btn--primary" type="button" onClick={handleSaveModal}>
                Guardar preferencias
              </button>
              <button className="bw-cookie-btn bw-cookie-btn--secondary" type="button" onClick={handleEssentialOnly}>
                Solo necesarias
              </button>
            </footer>
          </article>
        </div>
      )}
    </>
  );
};

export default CookiesConsentModal;